var _filter, _clipPath, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 169,
    viewBox: "0 0 139 169",
    width: 139,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 168.862,
    width: 139,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44 51h50v50h-50z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 17c0-9.38884 7.6112-17 17-17h97c9.389 0 17 7.61116 17 17v126.862c0 9.389-7.611 17-17 17h-97c-9.3888 0-17-7.611-17-17z",
    fill: "#049be5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 29.2185h131v104.6725h-65.5-32.75-32.75z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.813 74.0585c-1.0354-.9679-1.0884-2.591-.1213-3.6272.967-1.0362 2.5781-1.1028 3.628-.1221 2.7772 2.608 5.6288.2067 5.9448-.0752.944-.8457 2.3416-.8645 3.3035-.1017.1136.0889.2212.1905.3212.3024.9448 1.0559.8551 2.6781-.2008 3.6238-2.2757 2.0374-7.866 4.6857-12.8754 0zm48.5332-3.6545c.9448 1.0559.8551 2.6781-.2007 3.6238-2.275 2.0374-7.8661 4.6847-12.8746 0-1.0354-.9679-1.0884-2.591-.1222-3.6272.9662-1.0363 2.579-1.1029 3.628-.1222 2.7773 2.6081 5.6288.2067 5.9449-.0752.9439-.8457 2.3415-.8645 3.3034-.1016.1128.0888.2195.1913.3212.3024zm-3.8322 26.7358c.5621 1.2994-.035 2.808-1.3344 3.3702-1.2993.564-2.8062-.035-3.3683-1.3344-2.4723-5.7142-8.312-9.408-14.883-9.408-6.7205 0-12.597 3.6904-14.9684 9.4028-.4092.9836-1.3634 1.5806-2.3672 1.5806-.3271 0-.6603-.063-.9815-.197-1.307-.544-1.9264-2.0439-1.3839-3.3501 3.1693-7.6311 10.9029-12.5611 19.7019-12.5611 8.6152 0 16.3036 4.9052 19.5848 12.497z",
    fill: "#5e6064"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadTicket);
export default __webpack_public_path__ + "static/media/sadTicket.3bf0f4198e3b3ac6ea5e65a6d0865af9.svg";
export { ForwardRef as ReactComponent };